import script from "./SearchView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchView.vue?vue&type=script&lang=ts&setup=true"

import "./SearchView.vue?vue&type=style&index=0&id=9600a896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9600a896"]])

export default __exports__